/**
 * @flow
 * @relayHash 549851e99e31508bf1b03eccfefb2eae
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LoginAuthMutationVariables = {|
  username: string,
  password: string,
|};
export type LoginAuthMutationResponse = {|
  +tokenAuth: ?{|
    +token: string,
    +user: ?{|
      +id: string,
      +username: string,
      +userCategory: number,
      +userAccess: boolean,
    |},
  |}
|};
export type LoginAuthMutation = {|
  variables: LoginAuthMutationVariables,
  response: LoginAuthMutationResponse,
|};
*/


/*
mutation LoginAuthMutation(
  $username: String!
  $password: String!
) {
  tokenAuth(username: $username, password: $password) {
    token
    user {
      id
      username
      userCategory
      userAccess
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "username",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "password",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "tokenAuth",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "concreteType": "ObtainJSONWebToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "UserType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userCategory",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userAccess",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LoginAuthMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LoginAuthMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LoginAuthMutation",
    "id": null,
    "text": "mutation LoginAuthMutation(\n  $username: String!\n  $password: String!\n) {\n  tokenAuth(username: $username, password: $password) {\n    token\n    user {\n      id\n      username\n      userCategory\n      userAccess\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '89dc06b338784aa9c5c1f17fed62cb7d';
module.exports = node;
